Object.defineProperty(exports,"__esModule",{value:true});var _isEqual2=require("lodash/isEqual");var _isEqual3=_interopRequireDefault(_isEqual2);var _merge2=require("lodash/merge");var _merge3=_interopRequireDefault(_merge2);var _assign2=require("lodash/assign");var _assign3=_interopRequireDefault(_assign2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=require("react");var _react2=_interopRequireDefault(_react);
var _index=require("../victory-util/index");function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}


var defaultStyles={
fill:"#252525",
fontSize:14,
fontFamily:"'Gill Sans', 'Gill Sans MT', 'Ser­avek', 'Trebuchet MS', sans-serif",
stroke:"transparent"};var


VictoryLabel=function(_React$Component){_inherits(VictoryLabel,_React$Component);function VictoryLabel(){_classCallCheck(this,VictoryLabel);return _possibleConstructorReturn(this,(VictoryLabel.__proto__||Object.getPrototypeOf(VictoryLabel)).apply(this,arguments));}_createClass(VictoryLabel,[{key:"componentWillMount",value:function componentWillMount()










































































{
this.cacheAttributes(this.calculateAttributes(this.props));
}},{key:"cacheAttributes",value:function cacheAttributes(

attrs){var
style=attrs.style,dx=attrs.dx,dy=attrs.dy,content=attrs.content,textAnchor=attrs.textAnchor,transform=attrs.transform,lineHeight=attrs.lineHeight;
this.style=style;
this.dx=dx;
this.dy=dy;
this.content=content;
this.textAnchor=textAnchor;
this.lineHeight=lineHeight;
this.transform=transform;
}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(

nextProps){
var attrs=this.calculateAttributes(nextProps);var
style=attrs.style,dx=attrs.dx,dy=attrs.dy,content=attrs.content,lineHeight=attrs.lineHeight,textAnchor=attrs.textAnchor,transform=attrs.transform;var _props=
this.props,x=_props.x,y=_props.y;
if(
x!==nextProps.x||
y!==nextProps.y||
dx!==this.dx||
dy!==this.dy||
lineHeight!==this.lineHeight||
transform!==this.transform||
textAnchor!==this.textAnchor||
!(0,_isEqual3.default)(content,this.content)||
!(0,_isEqual3.default)(style,this.style))
{
this.cacheAttributes(attrs);
return true;
}
return false;
}},{key:"calculateAttributes",value:function calculateAttributes(

props){
var style=this.getStyles(props);
var fontSize=style[0].fontSize;
var lineHeight=this.getHeight(props,"lineHeight");
var textAnchor=props.textAnchor?
_index.Helpers.evaluateProp(props.textAnchor,props.datum):"start";
var content=this.getContent(props);
var dx=props.dx?_index.Helpers.evaluateProp(this.props.dx,props.datum):0;
var dy=this.getDy(props,style,content,lineHeight)*fontSize;
var transform=this.getTransform(props,style);
return{
style:style,dx:dx,dy:dy,content:content,lineHeight:lineHeight,textAnchor:textAnchor,transform:transform};

}},{key:"getStyle",value:function getStyle(

props,style){
style=style?(0,_merge3.default)({},defaultStyles,style):defaultStyles;
var datum=props.datum||props.data;
var baseStyles=_index.Helpers.evaluateStyle(style,datum,props.active);
return(0,_assign3.default)({},baseStyles,{fontSize:this.getFontSize(baseStyles)});
}},{key:"getStyles",value:function getStyles(

props){var _this2=this;
return Array.isArray(props.style)?
props.style.map(function(style){return _this2.getStyle(props,style);}):[this.getStyle(props,props.style)];
}},{key:"getHeight",value:function getHeight(

props,type){
var datum=props.datum||props.data;
return _index.Helpers.evaluateProp(props[type],datum,props.active);
}},{key:"getContent",value:function getContent(

props){
if(props.text===undefined||props.text===null){
return[" "];
}
var datum=props.datum||props.data;
if(Array.isArray(props.text)){
return props.text.map(function(line){return _index.Helpers.evaluateProp(line,datum,props.active);});
}
var child=_index.Helpers.evaluateProp(props.text,datum,props.active);
return(""+child).split("\n");
}},{key:"getDy",value:function getDy(

props,style,content,lineHeight){
var datum=props.datum||props.data;
var dy=props.dy?_index.Helpers.evaluateProp(props.dy,datum):0;
var length=content.length;
var capHeight=this.getHeight(props,"capHeight");
var verticalAnchor=style.verticalAnchor||props.verticalAnchor;
var anchor=verticalAnchor?
_index.Helpers.evaluateProp(verticalAnchor,datum):"middle";
switch(anchor){
case"end":
return dy+capHeight/2+(0.5-length)*lineHeight;
case"middle":
return dy+capHeight/2+(0.5-length/2)*lineHeight;
default:
return dy+capHeight/2+lineHeight/2;}

}},{key:"getTransform",value:function getTransform(

props,style){var
datum=props.datum,x=props.x,y=props.y;
var angle=style.angle||props.angle;
var transform=props.transform||style.transform;
var transformPart=transform&&_index.Helpers.evaluateProp(transform,datum);
var rotatePart=angle&&{rotate:[angle,x,y]};
return transformPart||angle?
_index.Style.toTransformString(transformPart,rotatePart):undefined;
}},{key:"getFontSize",value:function getFontSize(

style){
var baseSize=style&&style.fontSize;
if(typeof baseSize==="number"){
return baseSize;
}else if(baseSize===undefined||baseSize===null){
return defaultStyles.fontSize;
}else if(typeof baseSize==="string"){
var fontSize=+baseSize.replace("px","");
if(!isNaN(fontSize)){
return fontSize;
}else{
_index.Log.warn("fontSize should be expressed as a number of pixels");
return defaultStyles.fontSize;
}
}
return defaultStyles.fontSize;
}},{key:"renderElements",value:function renderElements(


props){var _this3=this;
var textProps={
dx:this.dx,dy:this.dy,x:props.x,y:props.y,
transform:this.transform,className:props.className};

return(
_react2.default.createElement("text",_extends({},textProps,
props.events),

this.content.map(function(line,i){
var style=_this3.style[i]||_this3.style[0];
var lastStyle=_this3.style[i-1]||_this3.style[0];
var fontSize=(style.fontSize+lastStyle.fontSize)/2;
var textAnchor=style.textAnchor||_this3.textAnchor;
var dy=i?_this3.lineHeight*fontSize:undefined;
return(
_react2.default.createElement("tspan",{key:i,x:props.x,dy:dy,dx:_this3.dx,style:style,textAnchor:textAnchor},
line));


})));


}},{key:"render",value:function render()

{
return this.renderElements(this.props);
}}]);return VictoryLabel;}(_react2.default.Component);VictoryLabel.displayName="VictoryLabel";VictoryLabel.role="label";VictoryLabel.propTypes={active:_react.PropTypes.bool,className:_react.PropTypes.string,angle:_react.PropTypes.oneOfType([_react.PropTypes.string,_react.PropTypes.number]),capHeight:_react.PropTypes.oneOfType([_react.PropTypes.string,_index.PropTypes.nonNegative,_react.PropTypes.func]),datum:_react.PropTypes.any,data:_react.PropTypes.array,index:_react.PropTypes.oneOfType([_react.PropTypes.number,_react.PropTypes.string]),events:_react.PropTypes.object,text:_react.PropTypes.oneOfType([_react.PropTypes.string,_react.PropTypes.number,_react.PropTypes.func,_react.PropTypes.array]),lineHeight:_react.PropTypes.oneOfType([_react.PropTypes.string,_index.PropTypes.nonNegative,_react.PropTypes.func]),style:_react.PropTypes.oneOfType([_react.PropTypes.object,_react.PropTypes.array]),textAnchor:_react.PropTypes.oneOfType([_react.PropTypes.oneOf(["start","middle","end","inherit"]),_react.PropTypes.func]),verticalAnchor:_react.PropTypes.oneOfType([_react.PropTypes.oneOf(["start","middle","end"]),_react.PropTypes.func]),transform:_react.PropTypes.oneOfType([_react.PropTypes.string,_react.PropTypes.object,_react.PropTypes.func]),x:_react.PropTypes.number,y:_react.PropTypes.number,dx:_react.PropTypes.oneOfType([_react.PropTypes.number,_react.PropTypes.string,_react.PropTypes.func]),dy:_react.PropTypes.oneOfType([_react.PropTypes.number,_react.PropTypes.string,_react.PropTypes.func])};VictoryLabel.defaultProps={capHeight:0.71,lineHeight:1};exports.default=VictoryLabel;


//////////////////
// WEBPACK FOOTER
// ./~/victory-core/lib/victory-label/victory-label.js
// module id = 292
// module chunks = 0